import * as React from 'react';


export class OOEditor extends React.Component<{},{}> {
    render() {
        return <div>Editort ide!</div>;
    }
}